import { render } from "./SupplierGradeTable.vue?vue&type=template&id=230063c8&scoped=true&ts=true&lang=pug"
import script from "./SupplierGradeTable.vue?vue&type=script&lang=ts"
export * from "./SupplierGradeTable.vue?vue&type=script&lang=ts"

import "./SupplierGradeTable.vue?vue&type=style&index=0&id=230063c8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230063c8"]])

export default __exports__